export default __webpack_public_path__ + "static/media/CNo.67-0.0b257b2b.jpg";